import { render, staticRenderFns } from "./MetadataVersionHistory.vue?vue&type=template&id=dc97998a&scoped=true"
import script from "./MetadataVersionHistory.vue?vue&type=script&lang=js"
export * from "./MetadataVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./MetadataVersionHistory.vue?vue&type=style&index=0&id=dc97998a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc97998a",
  null
  
)

export default component.exports